import { useEffect, useState } from 'react';

const MOBILE_WIDTH_THRESHOLD = 1000;

export const useIsMobile = () => {
  const getIsMobile = () => window.innerWidth < MOBILE_WIDTH_THRESHOLD;

  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const checkMobile = () => {
      // Check window width
      const isSmallScreen = getIsMobile();
      setIsMobile(isSmallScreen);
    };

    // Check on mount
    checkMobile();

    // Check on resize
    const handleResize = () => checkMobile();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
